exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conteiner {\r\n    background: #fff;\r\n}\r\n\r\n.preview-badge {\r\n    font-size: 9px;\r\n}\r\n\r\n.icon-layout {\r\n    font-size: 1.5em;\r\n    line-height: 0.75em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/layouts/layouts.component.css
// module id = ../../../../../src/app/layouts/layouts.component.css
// module chunks = main